import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './formLabel.scss'

const FormLabel = ({ htmlFor, text, description, className }) => {
	const componentClass = 'o-form-label'
	const cssClasses = classNames(
		componentClass,
		description && `${componentClass}--has-description`,
		className
	)

	return (
		<label className={cssClasses} htmlFor={htmlFor}>
			{text}

			{description && (
				<div className={`${componentClass}__description`}>
					{description}
				</div>
			)}
		</label>
	)
}

FormLabel.propTypes = {
	htmlFor: PropTypes.string,
	text: PropTypes.node,
	className: PropTypes.string,
	description: PropTypes.node,
}

FormLabel.defaultProps = {
	htmlFor: null,
	text: null,
	className: null,
	description: null,
}

export default FormLabel
